import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { firstValueFrom } from 'rxjs'
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root',
})
export class LogonService {
  constructor(private readonly http: HttpClient) {}

  public static readonly logonServiceEndpoint =
    environment.vfaPersonal1Url.concat('usa/authenticated')

  getLoggedOn(): Promise<boolean> {
    return firstValueFrom(
      this.http.get(LogonService.logonServiceEndpoint, {
        withCredentials: true,
        responseType: 'text',
      }),
    ).then(
      () => true,
      () => false,
    )
  }
}
